import React from "react";
import { Box, Button, Stack, Typography, styled } from "@mui/material";
import { Facebook, Instagram } from "@mui/icons-material/"
import SendIcon from '@mui/icons-material/Send';
import { SoundCloudIcon } from "../custom-icons/Soundcloud.jsx";
import { SpotifyIcon } from "../custom-icons/Spotify.jsx";
import { useNavigate } from "react-router-dom";

import "./Footer.css";


const SocialBox = styled(Box)({
  display: "flex",
  gap: 10,
  color: "white",
});

const Footer = () => {

  let navigate = useNavigate(); 
  const routeChange = () =>{ 
  let path = `/contact/`; 
    navigate(path);  
  }

  return (
    <Box
      className = "Contacts"
      sx={{ background: "black", height: "300px" }}>
      <Stack direction={{ xs: "row", md: "row" }} p={7}>
        <Box flex={1}>
              <Typography color={"white"} align={"center"}>
                Contact
              </Typography>
              {/* <Typography color={"white"} align={"center"}>
                  distorise@gmail.com
              </Typography> */}
          <Typography color={"white"} align={"center"}>
                <Button sx={{
                  backgroundColor: 'black',
                  '&:hover': {
                    color: "black",
                    backgroundColor: "white",
                  }
                  }}
                  onClick={routeChange}
                  variant="contained" 
                  endIcon={<SendIcon />}>
                  Send Message Right Now
                </Button>
          </Typography>
        </Box>
        <Box flex={1}>
          {/* <Typography color={"white"} align={"center"}>
            Data policy
          </Typography>
          <Typography color={"white"} align={"center"}>
            cookies
          </Typography>
          <Typography color={"white"} align={"center"}>
            Data Safety
          </Typography> */}
        </Box>
        <Box>
          <Typography padding={0.5} color={"white"} align={"center"}>
            Social Media            
          </Typography>          
          <SocialBox>                  

            <SpotifyIcon onClick={() => { window.location.href = 'https://open.spotify.com/artist/1l2XNMmYyIIMOIFY4HFsNU'; }} />
            <SoundCloudIcon onClick={() => { window.location.href = 'https://soundcloud.com/distorise'; }} />
            <Facebook 
                  onClick={() => { window.location.href = 'https://www.facebook.com/distorise/'; }}
                  sx = {{
                      cursor: "pointer",
                      bgcolor: "black",
                      '&:hover': {
                          color: "black",
                          bgcolor: "white",
                      }
                  }}
                  />
                  <Instagram 
                  onClick={() => { window.location.href = 'https://www.instagram.com/alan_distorise/'; }}
                  sx = {{
                      cursor: "pointer",
                      bgcolor: "black",
                      '&:hover': {
                          color: "black",
                          bgcolor: "white",
                      }
                  }}
                  />
          </SocialBox>
        </Box>
      </Stack>
    </Box>
  );
};

export default Footer;